export const locale = {
    lang: 'pl',
    data: {
        "New": "Nowe",
        "Name": "Nazwa",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Save": "Zapisz",
        "Customer sources": "Źródła klientów",
        "Customer source data": "Dane źródła klientów",
        "Name is required!": "Nazwa jest wymagana!"
    }
};
